import controller from "./program-preview.controller";

const ProgramPreview = (app) => {
  app
    .get("/program-preview/back", async ({ res, req }) => {
      window.history.back();
    })
    .get("/program-preview/:cycleId", controller);
};

export default ProgramPreview;
